import { client } from "../../infrastructure/graphql/client";
import { CHANGE_PASSWORD } from "../../infrastructure/graphql/settingsQuerries";

export class SettingsService {
  async changePassword(oldPassword, newPassword) {
    try {
      const result = await client.mutate({
        mutation: CHANGE_PASSWORD,
        variables: { oldPassword, newPassword },
      });

      console.log("RESULT KEYS:", Object.keys(result));
      console.log("Full result:", JSON.stringify(result, null, 2));

      const response = result.data?.changePassword;

      if (!response) {
        return { success: false, message: "No response from server" };
      }

      if (
        response.message &&
        response.message.includes("Password changed successfully")
      ) {
        return {
          success: true,
          message: response.message,
        };
      } else {
        return {
          success: false,
          message: response.message || "Password change failed",
        };
      }
    } catch (error) {
      console.error("Change password error:", error);
      const errorMessage = error.graphQLErrors?.[0]?.message || "Network error";
      return { success: false, message: errorMessage };
    }
  }
}